import { get, post } from '../axios'
import { z } from 'zod'
import type { Tier } from './tier'
import { pricing } from './pricing'

const upgradeResponseSchema = z.object({
    upgraded: z.boolean().optional(),
    // The payment the bank asks the customer to confirm (3D Secure) before the upgrade completes.
    clientSecret: z.string().optional(),
})

const upgradePreviewSchema = z.object({
    tier: z.string(),
    // The moment the amount is prorated from, sent back with the upgrade so it bills this amount.
    prorationDate: z.number(),
    // In cents, charged right away for the rest of the billing period; null during a trial, or when Stripe gave no
    // preview.
    chargedNow: z.number().nullable(),
    chargedNowInclVat: z.number().nullable(),
    trialEndsAt: z.coerce.date().nullable(),
    leavesOldPrices: z.boolean(),
    currency: z.string(),
})

export type UpgradePreview = z.infer<typeof upgradePreviewSchema>

export const fetchPricing = () => {
    return get(pricing, '/pricing')
}

export const redirectPortal = () => {
    return post(z.string(), '/redirect-portal', {})
}

export const fetchUpgradePreview = (tier: Tier) => {
    return get(upgradePreviewSchema, `/upgrade/preview?tier=${tier}`)
}

export const upgradeTier = (tier: Tier, prorationDate?: number) => {
    return post(upgradeResponseSchema, '/upgrade', { tier, prorationDate })
}

export const completeUpgrade = () => {
    return post(upgradeResponseSchema, '/upgrade/complete', {})
}
